module.exports = __webpack_public_path__ + "files/c7e49894187fef38f51f8f63d70a772b.svg";